import $ from 'jquery';
import Sinequa from './search/sinequa';
import Cookie from "../../utils/Cookie";
import Sobot from './search/sobot';

"use strict";

var keyword;
var profilsToDeactivate;

// Dom Elements
var $contentZone = null;
var searchApp = null;
var sobotApp = null;

var activateSobot = true;

// Const
var SELECTOR_CONTENT_ZONE = "#dcw_results_content";
var SELECTOR_SEARCH_KEYWORD = "#search-keyword";
var CLASS_SEARCH_OUTPUT = "dcw_results_output";

var SEARCH = {
    MESSAGE_NO_RESULT: "0 r\u00e9ponse  sur le site"
};

var COOKIE_PROFILE= "profilTiers";

/*
    Build dom if no query made (no ajax call to do)
 */
function buildEmptyQueryResult() {
    displayEmptySearch();
    displayContentZone();
}

function displayContentZone() {
    $contentZone.css('visibility', 'visible');
}

function displayEmptySearch() {
    // Display Gsa empty default text

	if ($("#id_results_output").length) {
		$("#id_results_output").empty();
		$("#id_results_output").removeClass().addClass(CLASS_SEARCH_OUTPUT).html(SEARCH.MESSAGE_NO_RESULT);
	}
	// For pages with old html :
	else {
		var pSearch = $('<p></p>')
			.attr("class",CLASS_SEARCH_OUTPUT)
			.append(document.createTextNode(SEARCH.MESSAGE_NO_RESULT));
		$contentZone.append(pSearch);
	}
	
	
}

function buildResultsPage() {
    // Build result of the search
    searchApp.buildSearchResults();
    displayContentZone();
}

function cleanKeyword(keyword) {
    // clean query string
    keyword = keyword.replace(/"([^"]+(?="))"/g, '$1').trim();

    if (keyword !== null && keyword !== undefined && keyword !== "") {
        keyword = atob(keyword);
    }

    return keyword;
}

function launchSobot(keyword) {
    sobotApp = new Sobot(keyword);
    sobotApp.initSobot();
}

function checkIfDisabled() {
    if (window.cmsGlobals.chatbotConfig.disabled) {
        return false;
    } else {
        return true;
    }
}

function checkProfil() {
    // Keep list of profils to deactivate
    if (window.cmsGlobals.chatbotConfig.profilToDeactivate && window.cmsGlobals.chatbotConfig.profilToDeactivate != "") {
        profilsToDeactivate = window.cmsGlobals.chatbotConfig.profilToDeactivate;
    } else {
        return true;
    }

    var listOfProfiles = profilsToDeactivate.split(',');
    var profilT = Cookie.getByName(COOKIE_PROFILE);
    var profileDeactivated = false;

    if (profilT === "") {
        return true;
    } else {
        listOfProfiles.forEach(function(profilToDeactivate){
            if (profilT.includes(profilToDeactivate)) {
                profileDeactivated = true;
            }
        });
    }

    if (profileDeactivated) {
        return false;
    } else {
        return true;
    }
}

const initSearchContext = function initSearchContext() {
	
    const hashValue = window.location.hash;
	const keyword = hashValue.indexOf("#keyword=") >= 0 ? hashValue.replace(/^#keyword=/, '') : undefined;

	//Sobot ?
    activateSobot = checkIfDisabled();
    if (activateSobot) {
        activateSobot = checkProfil();
    }

	// If on page resultats-recherche
	if (window.location.href.indexOf("resultats-recherche")>=0) {
		
		window.EventBusCMS.addEventListener('buildSearch', event => {
			if (event.detail.isReady === 'search') {
				buildResultsPage();
			}
		});

		$contentZone = $(SELECTOR_CONTENT_ZONE)

		var keywordSoClean="";
		if (keyword == null || keyword == undefined || keyword == "") {
		} else {
				
			var keywordClean = cleanKeyword(keyword); // Ascii
			var keywordlength = keywordClean.length-1;
			keywordSoClean = keywordClean.substr(0, keywordlength ); // without final character (b/p)
			if (keywordSoClean !="") {
				if (activateSobot) {
					launchSobot(keywordSoClean);
				}

				searchApp = new Sinequa($contentZone, keywordClean);
				
				/*/ Test 0 résultat
				var	origin = keywordClean.substr(keywordlength,1);
				if (origin=="0")
					searchApp.callSearchApiTest0resultat();
				else */
				searchApp.callSearchApi();
			}
		}
		// manage empty query case : if no search done then show : 0 results
		if (keywordSoClean=="") {
			if (activateSobot) {
				launchSobot("");
			}
			buildEmptyQueryResult();
		}	
	}

};

export{initSearchContext};


// WEBPACK FOOTER //
// ./src/js/cms/commons/search.js